import { loadStripe } from "@stripe/stripe-js";
import environment from "../env";

export const fetchAndLinkAccounts = async (clientSecret: string) => {
  //set 1 is to call lookup service to see if user is tokenized //or call lookUp+DebitOrTokenize to tokenize the user or debit if they already tokenized
  //TODO - clientSecret is response from the server when you call lookUP and the user is not tokenized
  // const clientSecret =;

  const stripe = await loadStripe(environment.stripePublicKey);
  const result = await stripe?.collectFinancialConnectionsAccounts({
    clientSecret: clientSecret,
  });

  if (!result || result.error) {
    throw result;
  } else if (result.financialConnectionsSession.accounts.length === 0) {
    return null;
  } else {
    //TODO - get all the account returned
    //Use this to filter out the accounts we need - "status": "active" and "supported_payment_method_types": ["us_bank_account"] = "us_bank_account"
    //send all the accounts that match the criteria to the backend to completeTokinization
    return result.financialConnectionsSession.accounts;
  }
};
